"use client";

import React from "react";
import { ChevronDown } from "lucide-react";
export default function CompromisoDeSostenibilidad() {
  return <section data-section-id="221648" id="compromiso-de-sostenibilidad" className="relative h-screen w-full overflow-hidden bg-cover bg-center bg-[url(https://wpvc-images.s3.us-east-1.amazonaws.com/images/1679911/img/industrial_sustainability_hero.png)] flex flex-col items-center justify-center">
      {}
      <div className="absolute inset-0 bg-black/50 z-0" />

      {}
      <div className="absolute top-6 left-6 z-20">
        <nav className="flex" aria-label="Breadcrumb">
          <ol className="inline-flex items-center space-x-1 md:space-x-3">
            <li className="inline-flex items-center">
              <span className="text-white text-[10px] md:text-xs font-bold tracking-[0.3em] uppercase">
                INICIO / SOSTENIBILIDAD
              </span>
            </li>
          </ol>
        </nav>
      </div>

      {}
      <div className="container mx-auto px-4 relative z-10 flex flex-col items-center justify-center text-center">
        <h1 className="flex flex-col items-center font-default text-white leading-[0.9] tracking-tighter animate-in fade-in slide-in-from-bottom-12 duration-1000">
          <span className="text-5xl sm:text-6xl md:text-8xl lg:text-9xl font-extrabold uppercase">
            EMPRESA SOCIALMENTE
          </span>
          <span className="text-5xl sm:text-6xl md:text-8xl lg:text-9xl font-extrabold uppercase">
            RESPONSABLE
          </span>
        </h1>
      </div>

      {}
      <div className="absolute bottom-8 left-1/2 -translate-x-1/2 z-20 flex flex-col items-center animate-bounce">
        <span className="text-white text-[10px] md:text-xs font-bold tracking-[0.4em] uppercase mb-2">
          SCROLL
        </span>
        <ChevronDown className="text-white size-5" />
      </div>
    </section>;
}